import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FullLayout from 'Components/Layout/Full';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';

import DefaultOrFDContentContainer from 'Components/Layout/DefaultOrFDContentContainer';
import useHomeContext from 'Context/HomeContext';
import FinancialWellnessComponentCard from './FinancialWellnessComponentCard';

const styles = theme => ({
  root: {
    padding: theme.spacing(4, 2, 2),
  },
  rootWhiteBackground: {
    backgroundColor: theme.palette.common.white,
  },
  components: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(4),
  },
  component: {
    flexBasis: '240px',
    margin: theme.spacing(1),
    '&:first-child': {
      marginLeft: 0,
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  componentsMobile: {
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  mobileComponent: {
    margin: theme.spacing(2, 0),
  },
});

const FinancialWellnessView = ({
  className,
  classes,
  collection,
  readOnly,
  TitleProps,
}) => {
  const [financialWellnessResource] = collection;
  const componentsColl = financialWellnessResource.attr('components');
  const wellnessItems = componentsColl?.resources().list() || [];
  const isMobile = useMobileLayout();
  const { hasLegacyDashboardImprovement } = useHomeContext();

  return (
    <FullLayout
      className={classNames(classes.root, className, {
        [classes.rootWhiteBackground]: !hasLegacyDashboardImprovement,
      })}
    >
      <DefaultOrFDContentContainer
        className={classes.content}
      >
        <Typography
          variant="h4"
          color="black"
          weight="bold"
          {...TitleProps}
        >
          {'Financial Wellness'}
        </Typography>
        <div
          className={classNames(classes.components, {
            [classes.componentsMobile]: isMobile,
          })}
        >
          {wellnessItems.map((resource) => {
            return (
              <FinancialWellnessComponentCard
                className={classNames(classes.component, {
                  [classes.mobileComponent]: isMobile,
                })}
                key={resource.id()}
                financialWellnessCollection={collection}
                resource={resource}
                readOnly={readOnly}
              />
            );
          })}
        </div>
      </DefaultOrFDContentContainer>
    </FullLayout>
  );
};

FinancialWellnessView.defaultProps = {
  className: '',
  readOnly: false,
};

FinancialWellnessView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

export default withStyles(styles)(FinancialWellnessView);
